import cms from 'shared/services/cms';

export async function validateEmail(email: string, authorizationToken: string) {
  const response = await cms.post('firebase/validate-email', {
    email,
    authorizationToken,
  });
  return response.data;
}
